import { apiClient } from "@/lib/apiClient";
import type {
  PersonnelGroup,
  PersonnelGroupDetail,
  PersonnelGroupsListParams,
} from "../types/personnel-groups.types";

const ENDPOINT = "/api/admin/personnel-groups";

export const personnelGroupsApi = {
  async create(payload: { name: string; description?: string }): Promise<PersonnelGroup> {
    const { data } = await apiClient.post<{ data?: PersonnelGroup }>(ENDPOINT, payload);
    return data?.data as PersonnelGroup;
  },

  async list(params: PersonnelGroupsListParams): Promise<{ items: PersonnelGroup[]; totalCount: number }> {
    const { data } = await apiClient.get<{
      data?: { items?: PersonnelGroup[]; totalCount?: number };
    }>(ENDPOINT, { params });
    return {
      items: data?.data?.items ?? [],
      totalCount: data?.data?.totalCount ?? 0,
    };
  },

  async getById(id: string, params?: { page?: number; limit?: number; unitId?: string }): Promise<PersonnelGroupDetail> {
    const { data } = await apiClient.get<{ data?: PersonnelGroupDetail }>(`${ENDPOINT}/${id}`, { params });
    return data?.data as PersonnelGroupDetail;
  },

  async update(id: string, payload: { name?: string; description?: string }): Promise<void> {
    await apiClient.patch(`${ENDPOINT}/${id}`, payload);
  },

  async remove(id: string): Promise<void> {
    await apiClient.delete(`${ENDPOINT}/${id}`);
  },

  async addMembers(id: string, userIds: string[]): Promise<void> {
    await apiClient.post(`${ENDPOINT}/${id}/members`, { userIds });
  },

  async removeMember(id: string, userId: string): Promise<void> {
    await apiClient.delete(`${ENDPOINT}/${id}/members/${userId}`);
  },
};
